<script setup lang="ts">
import { onMounted, ref } from "vue";
import { apiPathUrl } from "@/Utils/helpers";
import AppUserRow from "@/Components/App/users/AppUserRow.vue";
import { toast } from "vue-sonner";

type Props = {
    reviewId: string;
};
const { reviewId } = defineProps<Props>();
const users = ref([]);

// methods
const getReviewLikers = () => {
    axios
        .get(apiPathUrl(`/reviews/${reviewId}/likers`))
        .then((response: any) => {
            users.value = response.data.data;
        })
        .catch(() => {
            // set errors
            toast.error("Er ging iets mis bij het ophalen van de likers");
        });
};

onMounted(() => {
    getReviewLikers();
});
</script>

<template>
    <AppUserRow
        v-for="user in users"
        :user="user"
    />
</template>
